import React from 'react';
import { RootStore, createRootStore } from './RootStore';

export const rootStore = createRootStore();
export const RootStoreContext = React.createContext(rootStore);

export function useRootStore() {
  return React.useContext(RootStoreContext);
}